import React, { Fragment } from 'react';
import { compose } from 'redux';
import Button from '4all-ui/components/Button';
import Loader from '4all-ui/components/Loader';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import * as styles from './style';
import ProductsGeneralActions from './ProductsGeneralActions';
import ProductsSecondaryActions from './ProductsSecondaryActions';
import CategoryEmpty from './CategoryEmpty';
import CategoryList from './Categories/CategoryList';
import { ErrorHandler, Navbar } from '../../components';
import ProductActionModal from '../../components/GenericModal/ProductActionModal';
import ExportToMenuModal from '../../components/GenericModal/ExportToMenuModal';
import PlusIcon from '../../images/icon-plus.svg';
import withCategories from '../../containers/Categories';
import withProducts from '../../containers/Products';
import Helper from '../../helpers/Helper';
import {
  ENTITIES,
  GET_LIMIT,
  PRODUCT_CORE_ACTIONS,
  PRODUCT_ELEMENT_ID_PREFIX,
  PATHS,
} from '../../helpers/constants';
import {
  isSomeProductChecked,
  isProductCheckedOrInactive,
  formatProductsToBeDeleted,
} from '../../helpers/products';
import withScrollTo from '../../containers/ScrollTo';

class Product extends React.PureComponent {
  state = {
    categoriesFiltered: [],
    qtdFiltered: 0,
    isDeleted: false,
  };

  componentDidMount() {
    this.getProductsList(0);
    // window.addEventListener('scroll', this.onWindowScroll);
  }

  // componentWillUnmount() {
  //   window.removeEventListener('scroll', this.onWindowScroll);
  // }

  getProductsList = async offset => {
    await this.props.getCategoriesWithOffSetAndLimit(offset, GET_LIMIT);
    if (this.props.scrollTo.id) {
      this.checkElementToScroll(this.props.scrollTo);
    }
  };

  onSubmitActionModal = data => {
    const { isProductModal } = this.props;
    if (isProductModal(PRODUCT_CORE_ACTIONS.CHANGE_STATUS)) {
      this.handleChangeStatus(
        0,
        this.props.modalProduct.data.product.productId,
        this.props.modalProduct.data.product.categoryId
      );
    } else if (isProductModal(PRODUCT_CORE_ACTIONS.DELETE)) {
      this.prepareDelete(this.props.modalProduct.data);
    }
  };

  prepareDelete = async product => {
    await this.props.deleteProduct(formatProductsToBeDeleted(product));

    this.setState({ isDeleted: true });
  };

  handleChangeStatus = (status, idProduct, idCategory) => {
    let productToSave = null;
    let categoryToSave = null;
    const categoryList = [...this.props.categories];
    categoryList.forEach(category => {
      if (category.id === idCategory) {
        categoryToSave = category;
        category.products.forEach(product => {
          if (product.id === idProduct) {
            productToSave = {
              ...product,
              status,
            };
          }
        });
      }
    });

    if (productToSave) {
      const data = {
        ...productToSave,
        status,
        categories: [{ ...categoryToSave }],
      };

      this.props.updateProductStatus(productToSave.id, data);
    }

    this.setState({ ...this.state });
    this.props.closeProductModal();
  };

  onCloseActionModal = productRequestError => {
    if (productRequestError) {
      this.props.refreshProductsList();
    } else {
      this.props.refreshProductsList(this.state.isDeleted);
    }

    this.setState({ isDeleted: false });
  };

  onDragEnd = async result => {
    const { destination, source, draggableId } = result;

    if (!destination) return;

    const didNotMove =
      destination.droppableId === source.droppableId && destination.index === source.index;

    if (didNotMove) return;

    const categoryId = parseInt(destination.droppableId.split('_')[1], 0);
    const entity = draggableId.split('_')[0];

    const {
      orderProductItem,
      orderCategoryItem,
      sortOrderProduct,
      sortOrderCategory,
      categories,
    } = this.props;

    // Reordering
    if (source.droppableId === destination.droppableId) {
      const sortOrder = destination.index + 1;

      if (entity === ENTITIES.PRODUCT) {
        const category = categories.find(category => category.id === categoryId);
        const product = category.products[source.index];

        await sortOrderProduct({
          id: product.id,
          idCategory: categoryId,
          sortOrder,
        });

        orderProductItem(categoryId, source.index, destination.index);
      } else {
        const category = categories[source.index];

        await sortOrderCategory({
          id: category.id,
          sortOrder,
        });

        orderCategoryItem(source.index, destination.index);
      }
    }
  };

  // onWindowScroll = () => {
  // const d = document.documentElement;
  // const offset = d.scrollTop + window.innerHeight;
  // const height = document.body.scrollHeight;
  // if (offset === height) {
  //   this.getProductsList(this.state.offset);
  // }
  // };

  setNumberOfSelected = () => {
    let numberOfCategories = 0;
    let numberOfProducts = 0;

    this.state.categoryList.forEach(category => {
      if (category.checked) numberOfCategories++;
      numberOfProducts += category.products.filter(product => isProductCheckedOrInactive(product))
        .length;
    });
    this.setState({
      numberOfSelected: {
        categories: numberOfCategories,
        products: numberOfProducts,
        total: numberOfCategories + numberOfProducts,
      },
    });
  };

  toggleCategories = boolean => {
    const { setCollapseAllCategories } = this.props;

    setCollapseAllCategories(boolean);
  };

  checkElementToScroll = el => {
    const productElement = document.getElementById(`${PRODUCT_ELEMENT_ID_PREFIX}${el.id}`);
    if (productElement) {
      Helper.scrollToElement(productElement);
    }
    this.props.clearScrollTo();
  };

  showContent = () => {
    if (this.props.errorLoadingProducts) {
      return (
        <ErrorHandler>
          <div>
            <p>Opa, não conseguimos localizar nenhum</p>
            <p>produto, por favor tente recarregar a página.</p>
          </div>
        </ErrorHandler>
      );
    }

    const { categories, isLoadingProducts } = this.props;
    const { categoriesFiltered, qtdFiltered, textSearched } = this.state;
    const categoryList =
      categoriesFiltered.length || textSearched ? categoriesFiltered : categories;

    if (categories.length > 0) {
      const isDragDisabled = !categories.every(
        category => !category.isOpen || category.products.length === 0
      );

      const isFiltering = qtdFiltered > 0 || textSearched;

      return (
        <styles.Content>
          <styles.RowDetailsContainer isFiltering={isFiltering}>
            {isFiltering && (
              <styles.SearchMessageResult>
                {`${qtdFiltered} resultados para`}
                <span> "{textSearched}"</span>
              </styles.SearchMessageResult>
            )}

            {(!isFiltering || qtdFiltered !== 0) && (
              <styles.ToggleContainer>
                <Button
                  link
                  id="btn-toggle-categories"
                  onClick={() => this.toggleCategories(!isDragDisabled)}
                >
                  {isDragDisabled ? 'Recolher' : 'Expandir'} Todos
                </Button>
              </styles.ToggleContainer>
            )}
          </styles.RowDetailsContainer>

          <DragDropContext onDragEnd={this.onDragEnd} onBeforeDragStart={this.onBeforeDragStart}>
            <Droppable droppableId="droppableCategories">
              {provided => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <CategoryList
                    categoryList={categoryList}
                    onChangeStatus={this.handleChangeStatus}
                    isDragDisabled={qtdFiltered || isDragDisabled}
                    isProductDragDisabled={isFiltering}
                  />

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </styles.Content>
      );
    }

    if (!isLoadingProducts) {
      return <CategoryEmpty />;
    }

    return null;
  };

  filterCategories = ({ categories, qtdFiltered, textSearched }) => {
    this.setState({
      categoriesFiltered: categories,
      qtdFiltered,
      textSearched,
    });
  };

  render() {
    const { modalProduct, isProductModal, closeProductModal, categories } = this.props;
    const isAnyItemSelected = isSomeProductChecked(this.props.categories);
    return (
      <Fragment>
        <Navbar
          button={
            <Button
              id="btn-add-produto"
              onClick={() => this.props.history.push(PATHS.createProduct)}
              customStyles={{
                height: 50,
                paddingLeft: 15,
                paddingRight: 15,
                img: {
                  marginRight: 15,
                },
              }}
              disabled={categories.length === 0}
            >
              <img src={PlusIcon} alt="Ícone do botão de adicionar" />
              Criar Produto
            </Button>
          }
        >
          <styles.ProductsGeneralActionsContainer numberOfSelected={isAnyItemSelected}>
            <ProductsGeneralActions isSomeProductChecked={isAnyItemSelected} />
          </styles.ProductsGeneralActionsContainer>
        </Navbar>

        <styles.ProductList>
          <ProductsSecondaryActions
            categories={categories}
            filterCategories={this.filterCategories}
            refreshProductsList={this.props.refreshProductsList}
            insertCategoryInProductsList={this.props.insertCategoryInProductsList}
          />
          {this.props.isLoadingProducts && (
            <styles.ContentLoader>
              <Loader size="100px" width="8px" />
            </styles.ContentLoader>
          )}
          {this.showContent()}
        </styles.ProductList>
        <ProductActionModal
          onSubmitActionModal={this.onSubmitActionModal}
          onCloseActionModal={this.onCloseActionModal}
          changeProductStatusModal={isProductModal(PRODUCT_CORE_ACTIONS.CHANGE_STATUS)}
          isDeleted={this.state.isDeleted}
          onChangeProductStatus={this.handleChangeStatus}
          show={
            (isProductModal(PRODUCT_CORE_ACTIONS.DELETE) ||
              isProductModal(PRODUCT_CORE_ACTIONS.CHANGE_STATUS)) &&
            modalProduct.show
          }
        />

        <ExportToMenuModal
          close={closeProductModal}
          count={this.props.qttyProductsSelected.products}
          show={isProductModal(PRODUCT_CORE_ACTIONS.EXPORT) && modalProduct.show}
        />
      </Fragment>
    );
  }
}

export default compose(
  withCategories,
  withProducts,
  withScrollTo
)(Product);



// WEBPACK FOOTER //
// ./src/screens/Product/index.js